import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { IProficiency, IProficiencyResult } from "app/models/core/lab/proficiency";
import { SharedService } from "app/services/core/shared.service";
import { LabService } from "app/services/lab/lab.service";
import { AddLabProficiencyComponent } from "./addLabProficiency/addLabProficiency.component";
import { EditProficiencyResultComponent } from "./editProficiencyResult/editProficiencyResult.component";


@Component({
  selector: 'app-proficiency',
  templateUrl: './proficiency.component.html'
})

export class ProficiencyComponent implements OnInit {
  @Input() stateNumber: string = '';
  proficiencyList: IProficiency[] = [];

  displayedColumns: string[] = ['specialty', 'evaluator', 'subSpecialty',
    'testCode', 'analyte', 'testId', 'yrResult0_1', 'yrResult0_2', 'yrResult0_3', 'yrResult1_1', 'yrResult1_2', 'yrResult1_3'
  ];

  dataSource = new MatTableDataSource<IProficiency>(this.proficiencyList);


  selectedLab = '';
  listFilter = '';
  view = 'All';
  year = '';
  yearNum = 0;
  yearsList: string[];

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(public labService: LabService,
    public sharedService: SharedService,
    private modalService: MatDialog) { };

  ngOnInit() {
    if (this.labService.lab != null) {
      // Setting up years dropdown.
      this.yearNum = new Date().getFullYear();
      this.year = this.yearNum.toString();
      this.yearsList = [
        this.year,
        (this.yearNum - 1).toString(),
        (this.yearNum - 2).toString(),
        (this.yearNum - 3).toString(),
        (this.yearNum - 4).toString(),
        (this.yearNum - 5).toString(),
      ];
      this.getProficiencyList();
    }
  }

  getProficiencyList() {
    if (this.stateNumber != '') {
      this.labService.getProficiencyList(this.stateNumber).subscribe(
        res => {
          this.proficiencyList = res;
          this.dataSource.data = this.proficiencyList;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.processMatrix(this.yearNum);        },
        error => console.log('error: ', error),
        () => {

        }
      );
    }
  }

  processMatrix(yr: number) {
    this.proficiencyList.forEach(function (results) {
      let yr1 = yr;
      let yr0 = yr - 1;
      results.yrResult0_1 = null;
      results.yrResult0_2 = null;
      results.yrResult0_3 = null;
      results.yrResult1_1 = null;
      results.yrResult1_2 = null;
      results.yrResult1_3 = null;
      results.labResults.forEach(function (val) {
        val.comments = val.comments == '' ? null : val.comments;
        if (yr0 == val.year && val.period == '1') {
          results.yrResult0_1 = val;
        }
        if (yr0 == val.year && val.period == '2') {
          results.yrResult0_2 = val;
        }
        if (yr0 == val.year && val.period == '3') {
          results.yrResult0_3 = val;
        }
        if (yr1 == val.year && val.period == '1') {
          results.yrResult1_1 = val;
        }
        if (yr1 == val.year && val.period == '2') {
          results.yrResult1_2 = val;
        }
        if (yr1 == val.year && val.period == '3') {
          results.yrResult1_3 = val;
        }
      });
    });
  }

  getColor(percent: number): string {
    return percent < 80 ? 'red' : '';
  }

  addNewTest(): void {
    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = true;
    config.minWidth = 400;
    config.data = { stateNum: this.stateNumber };
    const dialogRef = this.modalService.open(AddLabProficiencyComponent, config);

    dialogRef.afterClosed().subscribe(
      data => {
        if (data != null) {
          this.getProficiencyList();
        }
      },
      error => console.log('error: ', error),
      () => { }
    );
  }

  addNewResult(yr: number, period: number, prof: IProficiency) {
    this.editResult(yr, period, prof);
  }

  editResult(yr: number, period: number, prof: IProficiency) {
    if (!this.labService.readonly) {

      let config = new MatDialogConfig<any>();
      let result: IProficiencyResult = null;

      prof.labResults.forEach(function (val) {
        if (yr == val.year && period.toString() == val.period) {
          result = val;
        }
      })
      config.autoFocus = true;
      config.disableClose = true;
      config.minWidth = 400;
      config.data = { year: yr, per: period, proficiency: result, profId: prof.proficiencyId };
      const dialogRef = this.modalService.open(EditProficiencyResultComponent, config);

      dialogRef.afterClosed().subscribe(
        data => {
          if (data != null) {
            this.getProficiencyList();
          }
        },
        error => console.log('error: ', error),
        () => { }
      );
    }

  }

  selectYear() {
    this.yearNum = +this.year;
    this.processMatrix(this.yearNum);
  }

  selectView() {

  }

  filterTable(evnt: Event) {
    this.listFilter = (evnt.target as HTMLInputElement).value;
    this.dataSource.filter = this.listFilter.trim().toLowerCase();
  }

  clearFilter() {
    this.listFilter = "";
    this.dataSource.filter = this.listFilter;
  }

  getPageSizeOptions(): number[] {
    if (this.dataSource.data.length > 20) {
      return [10, 20, this.dataSource.data.length];
    } else {
      return [10, 20];
    }
  }

}


